<template>
<div class="chapter">
<div class="inner_page">
<p class="block_"> </p>
<p class="block_"> </p>
<p class="block_"> </p>
<p class="block_"> </p>
<h1 class="block_1" id="toc_id_2">Dedication</h1>
<p class="block_"> </p>
<p class="block_"> </p>
<p class="block_"> </p>
<p class="block_4">I would like to dedicate this work to my daughters, Iyla and Lily, who are my everything and who believe in me no matter what is happening in life.</p>
<p class="block_5" id="calibre_pb_1"> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// index_split_001.vue?8592f2f4